import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format';
import addMonths from "date-fns/add_months";
import { addWeeks } from 'date-fns';
export default {
    namespaced: true,
    state: {
        organization1level:[],
        teamHeight:"",
        datachart:[],
        max_x:[],
        max_y:0,
        median_excel:0,
        median_improves:0,
        skillProficiencyAndDeficiency:[],
        skill:[],
        attributes:[],
        dataAll:[],
        skillProficiencyAndDeficiencyAll:[],
        statusTeam:false,
        skillProficiencyAndDeficiencyByteam:[],
        past9month:[],
        pageData:[],
        dataAlluser:[],
        teamsAll:[]

    },

    mutations: {
        setOrganization1level(state: any, value: any) {
            state.organization1level = value
          },
          setteamHeight(state: any, value: any) {
            state.teamHeight = value
          },
          setdatachart(state: any, value: any) {
            state.datachart = value
          },

          setskillProficiencyAndDeficiency(state: any, value: any) {
            state.skillProficiencyAndDeficiency = value
          },
          setSkill(state: any, value: any){
            state.skill = value
          },
          setAttributes(state: any, value: any){   
            state.attributes = value
          },
          setdataAll(state: any, value: any){   
            state.dataAll = value
          },
          setskillProficiencyAndDeficiencyAll(state: any, value: any){
            state.skillProficiencyAndDeficiencyAll = value
          },
          setPageData(state: any, value: any){
            state.pageData = value
          },
          setdataAlluser(state: any, value: any){
            state.dataAlluser = value
          },
          setteamsAll(state: any, value: any){
            state.teamsAll = value
          }
      
        
          
    },
    actions: {
        async getOrganization1level({ commit, state, rootState,dispatch }: any) {
            const organization1level = {}
            let team={}
            let topmostArr: Array<any> = [];
            let teamHeight:any
            await dispatch('main/getteam',true,{root:true})
            team = (await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
            for(const i in team){
                team[i].key=i
                if(!team[i].parent){
                  topmostArr.push(i)
                }
            }
            teamHeight = topmostArr[0]
            if(topmostArr.length > 1){
              teamHeight = _.find(topmostArr, (value) => {
              const chk_topmost = _.find(team, { parent: value });
              return !!chk_topmost;
              });
            }
            await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
            .then((querySnapshot)=> {
                    querySnapshot.forEach((doc)=> {
                      const data=doc.data()
                          if(!organization1level[data.team_id]){
                            organization1level[data.team_id]=data.parent
                          }               
                    });
                   
                    commit('setOrganization1level', organization1level)
                    commit('setteamHeight', teamHeight)
                    dispatch('getData')
            });
        },
        async getData({ commit, state,rootState,dispatch }: any,teamId:any) {
            dispatch('getmonth')
            const week_26=format(addWeeks(new Date(), -26), 'YYYY-MM-DD');
            const week_36=format(addWeeks(new Date(), -36), 'YYYY-MM-DD');
            const powerupMaster={
              'ps_critical_thinking':{order:1,name:'ps_critical_thinking',_name:'Critical Thinking',primary_color:"#F22F3C",secondary_color:"#F7CBCE"},
              'ps_empathy':{order:2,name:'ps_empathy',_name:'Empathy',primary_color:"#4F14C9",secondary_color:"#D0B9F5"},
              'ps_initiative_making':{order:3,name:'ps_initiative_making',_name:'Initiative Making',primary_color:"#8CE100",secondary_color:"#DCF0BF"},
              'ps_leadership':{order:4,name:'ps_leadership', _name:'Leadership',primary_color:"#00AA1A",secondary_color:"#BEE8B4"},
              'ps_self_awareness':{order:5,name:'ps_self_awareness',_name:'Self Awareness',primary_color:"#F77511",secondary_color:"#FDD5B9"},
              'ps_optimism':{order:6,name:'ps_optimism',_name:'Optimism',primary_color:"#F2D222",secondary_color:"#FFF1A8"}}
  
            if(teamId){
              const teams = (await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
              const allUser = rootState.main.allUser
              let dataAll=state.dataAll
              const user=state.dataAlluser
              let teamName=teams[teamId]?teams[teamId].name:""
              
              let team=state.organization1level[teamId]
              if(!team){
                  team={[teamId]:true}
              }
              if(teamId=="all"){
                 teamName="All Teams"
                  team=state.organization1level[state.teamHeight]
              }             
              const pageData:Array<any>=[]
                
              //power_tag
              for(const i in dataAll){
                  let sum_of_scores=0
                  let total=0
                  const barMonth:any={}
                  const databar:Array<any>=[]
                  const comavg:Array<any>=[]
                  const lineMonth:any={}
                  const linechart:Array<any>=[]
                  const userDatateam:Array<any>=[]
                  const userTop10:Array<any>=[]
                  const userAllData:Array<any>=[]
                  //team
                  for(const team_id in dataAll[i]){
                      
                      if(team[team_id]){
                          sum_of_scores=sum_of_scores+dataAll[i][team_id].point
                          total=total+dataAll[i][team_id].total
                          //month
                          for(const month in dataAll[i][team_id]){
                              // if(month>=format(addMonths(new Date(), -6), 'YYYY-MM')){
                              //     sum_of_scores=sum_of_scores+dataAll[i][team_id][month].point
                              // }
                              if(!barMonth[month]){
                                barMonth[month]={point:0,total:0}
                              }
                              barMonth[month].point=dataAll[i][team_id][month].point+parseInt(barMonth[month].point)
                              const uniq= _.uniq(dataAll[i][team_id][month].total_user);
                            
                               barMonth[month].total=Object.keys(uniq).length+parseInt(barMonth[month].total)
          
                              if(!lineMonth[month]){
                                lineMonth[month]={rating:0,total_rating:0}
                              }
                              lineMonth[month].rating=dataAll[i][team_id][month].rating+parseFloat(lineMonth[month].rating)
                              lineMonth[month].total_rating=dataAll[i][team_id][month].total_rating+parseInt(lineMonth[month].total_rating)
                              
                          }  
                          //user
                          for(const emailkey in user[i][team_id]){
                          
                            if(allUser[emailkey]){
                              userDatateam.push({emailkey:emailkey,point:user[i][team_id][emailkey].point,ratingAvj:isNaN(user[i][team_id][emailkey].rating/user[i][team_id][emailkey].time)?0:user[i][team_id][emailkey].rating/user[i][team_id][emailkey].time})
                            }
                            
                          }
                      }
                      
                  }
              
                  for(let i=8;i>=0;i--){
                    const monthly=format(addMonths(new Date(), -i), 'YYYY-MM')
                    if(barMonth[monthly]){
                      databar.push(barMonth[monthly].point)
                      comavg.push(parseInt(Math.round((barMonth[monthly].point/barMonth[monthly].total)).toFixed()))
                    }else{
                      databar.push(0)
                      comavg.push(0)
                    }
                    if(lineMonth[monthly]){
                      
                      linechart.push(parseFloat((lineMonth[monthly].rating/lineMonth[monthly].total_rating).toFixed(1)))
                    }else{
                      linechart.push(0)
                    }
                   
                    
                  }
                  
                  const sortData = _.orderBy(userDatateam, [
                    'point','ratingAvj'
                  ], ['desc']);
                 const top10 = _.slice(sortData, 0, 10)
                 for(const i in top10){
                  userTop10.push(
                    {
                      name: allUser[top10[i].emailkey].firstname+" "+allUser[top10[i].emailkey].lastname,
                      id: top10[i].emailkey,
                      teamname: teams[allUser[top10[i].emailkey].team].name,
                      imageProfile: allUser[top10[i].emailkey].profilepic,
                      rating: top10[i].ratingAvj.toFixed(1),
                      score:  top10[i].point,
                      bar: Math.round(((top10[i].point*100)/top10[0].point)),
                    }
                  )
                 }
   
                 for(const id in userDatateam){
                 
                  userAllData.push(
                    {
                      name: allUser[userDatateam[id].emailkey].firstname+" "+allUser[userDatateam[id].emailkey].lastname,
                      id: userDatateam[id].emailkey,
                      teamname: teams[allUser[userDatateam[id].emailkey].team].name,
                      imageProfile: allUser[userDatateam[id].emailkey].profilepic,
                      rating: userDatateam[id].ratingAvj.toFixed(1),
                      score:  userDatateam[id].point,
                      bar: Math.round(((userDatateam[id].point*100)/top10[0].point)),
                    }
                  )
                }
                  pageData.push({
                      id:powerupMaster[i].name,
                      title:powerupMaster[i]._name,
                      score: isNaN((sum_of_scores/total)* 100)?0:Math.round((sum_of_scores/total)* 100).toFixed(),
                      primaryColor: powerupMaster[i].primary_color,
                      secondaryColor: powerupMaster[i].secondary_color,
                      chartReader: null, // keep null
                      barChartData: {
                          labels:state.past9month,
                          datasets: [
                            {
                              label: teamName,
                              data: databar,
                            },
                            {
                              label: "Company Avg.",
                              data: comavg,
                            },
                          ],
                      },

                      lineChartData: {
                        labels: state.past9month,
                        datasets: [
                          {
                            label: "Rating",
                            data: linechart,
                          },
                        ],
                      },
                      Leaderboards: userTop10,
                      all:userAllData,
                  })
                  
              }
   
              commit('setPageData',pageData)
              
              

            
            }else{
                const datateam:any=[]
                const datateamImproves:any=[]
                const data:any=[]
                const teams = (await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
                const allUser = rootState.main.allUser
                const team=state.organization1level[state.teamHeight]
                let dataAll:Array<any>=[]
                const user:any={}

                
                var promise1 = new Promise(function(resolve, reject) {

                  firebase.firestore().collection('power_tag').where('company','==',rootState.authen.user.company).where('createdate','>=',week_26).get().then((querySnapshot)=>{
                    querySnapshot.forEach(async (doc) => {
                      const data=doc.data()
                      if(allUser[data.email.replace(/\./g, '||')]){
                        data.team=allUser[data.email.replace(/\./g, '||')].team
                        if(!dataAll[data.power_tag]){
                          dataAll[data.power_tag]={}
                        }
                        if(!dataAll[data.power_tag][data.team]){
                          dataAll[data.power_tag][data.team]={point:0,total:0}
                        }
                        dataAll[data.power_tag][data.team].point=parseFloat(data.point)+dataAll[data.power_tag][data.team].point
                        if(data.point<80){
                          dataAll[data.power_tag][data.team].total=dataAll[data.power_tag][data.team].total+80
                        }else{
                          dataAll[data.power_tag][data.team].total=dataAll[data.power_tag][data.team].total+parseFloat(data.point)
                        }
                      }

                    })
       
                    resolve("done");
                  })
                  
                });
                var promise2 = new Promise(function(resolve, reject) {

                  firebase.firestore().collection('toneanalyze').where('company','==',rootState.authen.user.company).where('date','>=',week_36).get().then((querySnapshot)=>{
                    querySnapshot.forEach(async (doc) => {
                    const data=doc.data()
                   // console.log('data',data)
                    const dateMonth= format(new Date(data.date), 'YYYY-MM');
                    const emailKey=data.email.replace(/\./g, '||')
                        if(data.power_skill &&allUser[emailKey]&&data.type=='question'){
                            data.team=allUser[emailKey].team
                            if(!dataAll[data.power_skill]){
                                dataAll[data.power_skill]={}
                            }
                            if(!dataAll[data.power_skill][data.team]){
                                dataAll[data.power_skill][data.team]={point:0,total:0}
                            }
                            if(!dataAll[data.power_skill][data.team][dateMonth]){
                                dataAll[data.power_skill][data.team][dateMonth]={ point:0,total:0,rating:0,total_rating:0,total_user:[]}
                            }
                        
                            dataAll[data.power_skill][data.team][dateMonth].point=dataAll[data.power_skill][data.team][dateMonth].point+parseInt(data.effort)
                            dataAll[data.power_skill][data.team][dateMonth].total=dataAll[data.power_skill][data.team][dateMonth].total+1
                            dataAll[data.power_skill][data.team][dateMonth].total_user.push(emailKey)

                            if(dateMonth>=week_26){
                                
                                if(!user[data.power_skill]){
                                  user[data.power_skill]={}
                                }
                                if(user[data.power_skill][data.power_skill]){
                                  user[data.power_skill][data.power_skill]={}
                                }
                                if(!user[data.power_skill][data.team]){
                                  user[data.power_skill][data.team]={}
                                }
                                if(!user[data.power_skill][data.team][emailKey]){
                                  user[data.power_skill][data.team][emailKey]={point:0,rating:0,time:0}
                                }
                                
                                if(data.rating&&data.rating>0){
                                  user[data.power_skill][data.team][emailKey].rating=user[data.power_skill][data.team][emailKey].rating+parseFloat(data.rating)
                                  user[data.power_skill][data.team][emailKey].time=user[data.power_skill][data.team][emailKey].time+1
                                }
                               
                                user[data.power_skill][data.team][emailKey].point=user[data.power_skill][data.team][emailKey].point+parseFloat(data.effort)
                            }

                            if(data.rating&&data.rating>0){
                              dataAll[data.power_skill][data.team][dateMonth].rating=dataAll[data.power_skill][data.team][dateMonth].rating+parseFloat(data.rating)
                              dataAll[data.power_skill][data.team][dateMonth].total_rating=dataAll[data.power_skill][data.team][dateMonth].total_rating+1
                            }
                           
                        }
                      
                    })
                    resolve('done')
                })
                 
                });

                Promise.all([promise1, promise2]).then((values)=> {

                  const pageData:Array<any>=[]
           
                  //power_tag
                  for(const i in dataAll){
                      let sum_of_scores=0
                      let total=0
                      const barMonth:any={}
                      const databar:Array<any>=[]
                      const comavg:Array<any>=[]
                      const lineMonth:any={}
                      const linechart:Array<any>=[]
                      const userDatateam:Array<any>=[]
                      const userTop10:Array<any>=[]
                      const userAllData:Array<any>=[]
                      
                      //team
                      for(const team_id in dataAll[i]){
                          
                          if(team[team_id]){

                              sum_of_scores=sum_of_scores+dataAll[i][team_id].point
                              total=total+dataAll[i][team_id].total
                              //month
                              for(const month in dataAll[i][team_id]){
                               
                                  if(!barMonth[month]){
                                    barMonth[month]={point:0,total:0}
                                  }
                                  barMonth[month].point=dataAll[i][team_id][month].point+parseInt(barMonth[month].point)
                                  const uniq= _.uniq(dataAll[i][team_id][month].total_user);
                                
                                   barMonth[month].total=Object.keys(uniq).length+parseInt(barMonth[month].total)
                                  // console.log('ssss',Object.keys(uniq).length)
                                  if(!lineMonth[month]){
                                    lineMonth[month]={rating:0,total_rating:0}
                                  }
                                  lineMonth[month].rating=dataAll[i][team_id][month].rating+parseFloat(lineMonth[month].rating)
                                  lineMonth[month].total_rating=dataAll[i][team_id][month].total_rating+parseInt(lineMonth[month].total_rating)
                                  
                              }  
                              //user
                              for(const emailkey in user[i][team_id]){
                             
                                if(allUser[emailkey]){
                     
                                  userDatateam.push({emailkey:emailkey,point:user[i][team_id][emailkey].point,ratingAvj:isNaN(user[i][team_id][emailkey].rating/user[i][team_id][emailkey].time)?0:user[i][team_id][emailkey].rating/user[i][team_id][emailkey].time})
                                }
                                
                              }
                              
                          }
                          
                      }
                  
                      for(let i=8;i>=0;i--){
                        const monthly=format(addMonths(new Date(), -i), 'YYYY-MM')
                        if(barMonth[monthly]){
                          databar.push(barMonth[monthly].point)
          
                          comavg.push(parseInt(Math.round((barMonth[monthly].point/barMonth[monthly].total)).toFixed()))
                        }else{
                          databar.push(0)
                          comavg.push(0)
                        }
                        if(lineMonth[monthly]){
                          
                          linechart.push(parseFloat((lineMonth[monthly].rating/lineMonth[monthly].total_rating).toFixed(1)))
                        }else{
                          linechart.push(0)
                        }
                       
                        
                      }
                      

                      
                      const sortData = _.orderBy(userDatateam, [
                        'point','ratingAvj'
                      ], ['desc']);
                     const top10 = _.slice(sortData, 0, 10)
      
                     for(const i in top10){
                      userTop10.push(
                        {
                          name: allUser[top10[i].emailkey].firstname+" "+allUser[top10[i].emailkey].lastname,
                          id: top10[i].emailkey,
                          teamname: teams[allUser[top10[i].emailkey].team].name,
                          imageProfile: allUser[top10[i].emailkey].profilepic,
                          rating: top10[i].ratingAvj.toFixed(1),
                          score:  top10[i].point,
                          bar: Math.round(((top10[i].point*100)/top10[0].point)),
                        }
                      )
                     }
                     for(const i in userDatateam){
                      userAllData.push(
                        {
                          name: allUser[userDatateam[i].emailkey].firstname+" "+allUser[userDatateam[i].emailkey].lastname,
                          id: userDatateam[i].emailkey,
                          teamname: teams[allUser[userDatateam[i].emailkey].team].name,
                          imageProfile: allUser[userDatateam[i].emailkey].profilepic,
                          rating: userDatateam[i].ratingAvj.toFixed(1),
                          score:  userDatateam[i].point,
                          bar: Math.round(((userDatateam[i].point*100)/top10[0].point)),
                        }
                      )
                      }

                      pageData.push({
                          id:powerupMaster[i].name,
                          title:powerupMaster[i]._name,
                          score: isNaN((sum_of_scores/total)* 100)?0:Math.round((sum_of_scores/total)* 100).toFixed(),
                          primaryColor: powerupMaster[i].primary_color,
                          secondaryColor: powerupMaster[i].secondary_color,
                          chartReader: null, // keep null
                          barChartData: {
                              labels:state.past9month,
                              datasets: [
                                {
                                  label: "TeamName",
                                  data: databar,
                                },
                                {
                                  label: "Company Avg.",
                                  data: comavg,
                                },
                              ],
                          },

                          lineChartData: {
                            labels: state.past9month,
                            datasets: [
                              {
                                label: "Rating",
                                data: linechart,
                              },
                            ],
                          },
                          Leaderboards: userTop10,
                          all:userAllData,
                      })
                     // console.log('userTop10',userTop10)
                  }
                  
                    commit('setPageData',pageData)
                    commit('setdataAll',dataAll)
                    commit('setdataAlluser',user)
                    commit('setteamsAll',teams)
                    if(rootState.authen.user.user_type == 'leadership'){
                      // console.log('rootState.authen.user.team', rootState.authen.user.team)
                      dispatch("getData", rootState.authen.user.team);
                  }else {
                      state.loading=false
                  }

                 })

               
                

            }
           
     
            
        },
        sortData({ commit, state,rootState,dispatch }: any,value:any) {
          // const dataSort=state.pageData[value.index]
          let sortData:Array<any>=[]
          let top10:Array<any>=[]
          const type=value.sort
          for(const i in state.pageData){
            const dataSort=state.pageData[i]
            if(type=="Descending Score"){
              sortData = _.orderBy(dataSort.all, [
               'score'
             ], ['desc']);
             top10= _.slice(sortData, 0, 10)
             
           }else if(type=="Descending Rating"){
              const fiilter=_.filter(dataSort.all, function(o) { return o.score>250; });
              sortData = _.orderBy(fiilter, [
               'rating'
             ], ['desc']);
             top10= _.slice(sortData, 0, 10)
           }
           else if(type=="Ascending Score"){
              sortData = _.orderBy(dataSort.all, [
               'score'
             ], ['asc']);
             top10= _.slice(sortData, 0, 10)
           }else if(type=="Ascending Rating"){
              sortData = _.orderBy(dataSort.all, [
               'rating'
             ], ['asc']);
             top10= _.slice(sortData, 0, 10)
           }
           state.pageData[i].Leaderboards=top10
          }
          commit('setPageData',state.pageData)
        },
        getmonth({ commit, state,rootState,dispatch }: any) {
            const month:Array<any>=[]
            for(let i=8;i>=0;i--){
                month.push(format(addMonths(new Date(), -i), 'MMM'))
            }
            state.past9month=month
        }
    },
    getters: {
        datachart : (state:any) => {
            return state.datachart
        },
        pageData : (state:any) => {
            return state.pageData
        },
        teamsAll: (state:any) => {
          return state.teamsAll
      },
        

    }
}